import { Form, Formik } from 'formik';
import { bool, func } from 'prop-types';
import React from 'react';
import { Button, Modal, Text, Stack, ButtonGroup, AnchorTextLink, Input } from '@chaser/components';
import usePush from '../../hooks/usePush';
import AccountService from '../../services/account-service';
import LabeledFieldWithError from '../LabeledFieldWithError';

const SupportModal = ({ initialSubject = '', disableSubject = false, open, close, onClosed }) => {
  const { execute, loading } = usePush(AccountService.sendSupportMessage, {
    errorToast: true,
    successToast: 'Message sent to support',
  });

  return (
    <Formik
      initialValues={{
        subject: initialSubject,
        message: '',
        _open: open, // to-reinitialize form when opening/closing
      }}
      onSubmit={async (values, actions) => {
        const [err] = await execute(values);
        actions.setSubmitting(false);
        if (err) return;
        close();
      }}
      enableReinitialize
    >
      {({ values }) => (
        <Modal
          open={open}
          toggle={close}
          onClosed={onClosed}
          title="Support"
          body={
            <Form>
              <Stack gap="medium">
                <Text>
                  We'd love to hear your comments or questions about Chaser. Please check our{' '}
                  <AnchorTextLink monochrome href="https://help.chaserhq.com/">
                    Help Centre
                  </AnchorTextLink>
                  , send an email to{' '}
                  <AnchorTextLink monochrome href="mailto:support@chaserhq.com">
                    support@chaserhq.com
                  </AnchorTextLink>{' '}
                  or leave us a message below. We'll get back to you as soon as we can.
                </Text>
                <LabeledFieldWithError
                  label="Subject"
                  name="subject"
                  disabled={disableSubject}
                  as={Input}
                  maxLength="92"
                  placeholder="What is your message about?"
                  width="100%"
                />
                <LabeledFieldWithError
                  label="Message"
                  name="message"
                  as={Input}
                  type="textarea"
                  placeholder="Write your question, suggestion or feedback here"
                  width="100%"
                />
              </Stack>
            </Form>
          }
          footer={
            <Form>
              <ButtonGroup>
                <Button type="button" appearance="secondary" onClick={() => close()}>
                  Cancel
                </Button>
                <Button
                  type="submit"
                  loading={loading}
                  disabled={!values.subject || !values.message}
                >
                  Send message
                </Button>
              </ButtonGroup>
            </Form>
          }
        />
      )}
    </Formik>
  );
};

SupportModal.propTypes = {
  open: bool.isRequired,
  toggle: func.isRequired,
};

export default SupportModal;
